import type { BlockType } from '@root/@types/types';

import type { BlockLayoutOption } from './types';

export const findOptionWithFallback = (options: BlockLayoutOption[], type: BlockType): BlockLayoutOption =>
  options.find((o) => o.type === type) ?? options[0];
